import { DataValveCDMEvent } from '@jarvis/shell-commons/dist/interface/v1/analytics/types'

import { DEVICE_SETUP_CHECK_EVENT } from '@/constants/analytics'
import {
  ResourceFetchingStatusDetails,
  ResourceResultDetails,
} from '@/services/analytics'

/**
 * Spec: {@link https://rndwiki.inc.hpicorp.net/confluence/spaces/CDM/pages/1325177110/deviceSetupCheck+Category, Device Setup Check event}
 */
export const buildDeviceSetupCheckEvent = (
  resourceFetchingStatusDetails: ResourceFetchingStatusDetails,
  resourceResultDetails: ResourceResultDetails,
): DataValveCDMEvent[] => [
  {
    eventDetail: {
      checkInfo: {
        checkSource: 'iot',
        ...resourceFetchingStatusDetails,
      },
      ...resourceResultDetails,
      version: DEVICE_SETUP_CHECK_EVENT.VERSION,
    },
    dateTime: new Date().toISOString(),
    eventDetailType: DEVICE_SETUP_CHECK_EVENT.EVENT_DETAIL_TYPE,
    eventCategory: DEVICE_SETUP_CHECK_EVENT.EVENT_CATEGORY,
    version: DEVICE_SETUP_CHECK_EVENT.ENVELOPE_VERSION,
  },
]
